/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PlcHttpConfig, PlcHttpConfigToken } from './services.models';

export type ImagesUploadFormData = { file: File; userId: string };
export type ImagesToonifyFormData = { file: File };

@Injectable()
export class ImagesService {
	constructor(
		@Inject(PlcHttpConfigToken) private config: PlcHttpConfig,
		private http: HttpClient,
	) {}

	public upload(body: ImagesUploadFormData): Observable<string> {
		const formData = new FormData();
		formData.append('file', body.file);
		formData.append('userId', body.userId);
		return this.http.post(
			`${this.config.apiUrl}/api/v2/private/images`,
			formData,
			{ responseType: 'text' },
		);
	}

	public toonify(body: ImagesToonifyFormData): Observable<string> {
		const formData = new FormData();
		formData.append('file', body.file);
		return this.http.post(
			`${this.config.apiUrl}/api/v2/private/images/toonify`,
			formData,
			{ responseType: 'text' },
		);
	}
}
